import { ReactNode } from 'react';
import { UiNotify } from 'znanie-uikit';
import dynamic from 'next/dynamic';

import { AuthProvider } from 'components/context/AuthContext';
import PageChangeObserver from 'components/common/PageChangeObserver';
import ScrollUpButton from 'components/widget/ScrollUpButton';
import Layout from 'components/layout/Layout';

const Draft: any = dynamic(() => import('components/widget/Draft'), {
  ssr: false,
});
const SupportChatBot: any = dynamic(
  () => import('components/widget/SupportChatBot'),
  { ssr: false }
);
const SearchDesktop: any = dynamic(
  () => import('components/common/search/SearchDesktop'),
  {
    ssr: false,
  }
);
const SearchMobile: any = dynamic(
  () => import('components/common/search/SearchMobile'),
  {
    ssr: false,
  }
);

const InterviewWidget: any = dynamic(
  () => import('components/widget/Interview'),
  {
    ssr: false,
  }
);

interface IAppContainerProps {
  children: ReactNode;
}

export default function AppContainer({ children }: IAppContainerProps) {
  return (
    <AuthProvider>
      <PageChangeObserver />
      <ScrollUpButton />
      <Draft />
      <SupportChatBot />
      <UiNotify />
      <InterviewWidget />
      <SearchDesktop />
      <SearchMobile />
      <Layout>{children}</Layout>
    </AuthProvider>
  );
}
